import { render, staticRenderFns } from "./VesselDocumentExpiryDialog.vue?vue&type=template&id=5a9fba1e"
import script from "./VesselDocumentExpiryDialog.vue?vue&type=script&lang=ts"
export * from "./VesselDocumentExpiryDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports